export interface DynamicLayerMetadataItem {
  id: number;
  name: string;
}

interface DynamicLayerMetadataResponse {
  layers?: DynamicLayerMetadataItem[];
}

const dynamicLayerMetadataLayers = (
  error: unknown,
  metadata: DynamicLayerMetadataResponse | null
) => {
  const layers = metadata?.layers;
  if (error || !Array.isArray(layers)) {
    return undefined;
  }

  return layers;
};

export default dynamicLayerMetadataLayers;
